/**
 * TipoResponsavelUsuario
 * @author Simpli CLI generator
 */
import {ID, Resource, TAG} from 'simpli-web-sdk'

export default class TipoResponsavelUsuario extends Resource {
  readonly $name: string = 'TipoResponsavelUsuario'

  readonly $endpoint: string = '/user/tipo-responsavel-usuario{/id}'

  get $id() {
    return this.idTipoResponsavelUsuarioPk
  }
  set $id(val: number) {
    this.idTipoResponsavelUsuarioPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idTipoResponsavelUsuarioPk: number = 0
  nome: string = ''
}
